import React from "react";
import classnames from "classnames";
import { format } from "date-fns";
import LazyLoad from "react-lazyload";
import { IGood } from "../../api";
import Countdown from "../Countdown";

import styles from "./Good.module.css";

interface GoodProp {
  goodInfo: IGood;
}

function Good(props: GoodProp) {
  const {
    accessNumber,
    assessmentPriceCN,
    auctionStatus,
    bidCount,
    currentPriceCN,
    displayStatus,
    endTime,
    remainTime,
    id,
    productImage,
    province,
    startTime,
    title,
    uvCount,
    disposeTotalUnit
  } = props.goodInfo
  
  const YUGAO = auctionStatus === 0; // 预告
  const JINXING = auctionStatus === 1; // 进行
  const JIESHU = auctionStatus === 2; // 结束

  const bigFont = currentPriceCN && currentPriceCN.length < 10;

  const showAssessmentPrice = assessmentPriceCN && assessmentPriceCN !== "0";
  const showTimes =
    YUGAO || displayStatus === 5 || displayStatus === 6 || displayStatus === 7;

  return (
    <div
      className={classnames(styles.good, {
        [styles.good0]: auctionStatus === 0,
        [styles.good1]: auctionStatus === 1,
        [styles.good2]: auctionStatus === 2
      })}
    >
      <a
        className={styles.link}
        href={`//paimai.jd.com/${id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {" "}
      </a>
      <div className={styles.pic}>
        <LazyLoad height={192}>
          <img
            src={`//img1${id %
              5}.360buyimg.com/imgw/s288x1000_${productImage}!q80!cc_3x2`}
            alt={title}
          />
        </LazyLoad>
      </div>
      <div className={styles.body}>
        <div className={styles.name} title={title}>
          {title}
        </div>
        <div className={styles.row1}>
          {province && province!='其他' &&
            <div className={styles.location}>
              <i className={styles.locationIcon}></i>
              <em className={styles.locationText}>{province}</em>
            </div>
          }
          {
            !!currentPriceCN && <div className={classnames(styles.price, { [styles.priceBig]: bigFont})}>
              <span className={styles.label}>{YUGAO ? "起始价" : "当前价"}:</span>
              <em className={styles.wrapper}>
                <i className={styles.symbol}>&#65509;</i>
                <b className={styles.value}>{currentPriceCN}</b>
                <i className={styles.symbol}>{disposeTotalUnit ? `/${disposeTotalUnit}`: '' }</i>
              </em>
            </div>
          }
        </div>
        <div className={styles.row2}>
          <div className={styles.times}>
            {showTimes ? <>{uvCount}次围观</> : <>{bidCount}次出价</>}
          </div>
          {showAssessmentPrice && (
            <div className={styles.asscess}>
              <span className={styles.label}>评估价:</span>
              <em className={styles.value}>&#65509;{assessmentPriceCN}</em>
            </div>
          )}
        </div>
      </div>
      <div className={styles.foot}>
        <div className={styles.status}>
          {YUGAO && "预告中"}
          {JINXING && "进行中"}
          {JIESHU && "已结束"}
        </div>
        <div className={styles.countdown}>
          {YUGAO && (
            <>
              开始时间：
              {format(startTime, "MM月dd日 HH:mm")}
            </>
          )}
          {JINXING && <Countdown remainTime={remainTime}/>}
          {JIESHU && (
            <>
              结束时间：
              {format(endTime, "MM月dd日 HH:mm")}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Good;
